import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPermissionMemberState } from '../types/permission-member';
import { getPermissionMembersThunk } from '../thunks/permissionMemberThunk';
import { IPermissionMemberResponse } from '@/shared/services/interface/responses/ICompanyResponses';

const initialState: IPermissionMemberState = {
  permissionMembers: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    limit: 10,
    nextOffset: 0,
    hasNext: false,
    hasPrevious: false,
  },
};

export const permissionMemberSlice = createSlice({
  name: 'permissionMember',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    clearPermissionMembers: (state) => {
      state.permissionMembers = [];
      state.pagination = initialState.pagination;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPermissionMembersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPermissionMembersThunk.fulfilled, (state, action: PayloadAction<IPermissionMemberResponse>) => {
        state.loading = false;
        state.permissionMembers = action.payload;
        // API'den pagination bilgisi gelmedğigi için sabit değerler kullanıyoruz
        state.pagination = {
          currentPage: 1,
          totalPages: 1,
          totalCount: action.payload.length,
          limit: action.payload.length || 30,
          nextOffset: 0,
          hasNext: false,
          hasPrevious: false,
        };
        state.error = null;
      })
      .addCase(getPermissionMembersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading, clearPermissionMembers } = permissionMemberSlice.actions;

export default permissionMemberSlice.reducer; 